import {AbstractControl, ValidatorFn} from "@angular/forms";

export function PhonevalidatorDirective(): ValidatorFn {

    return (control: AbstractControl): {[key: string]: any} => {
        if(!(control.value && control.value.length > 0)) {
            return null;
        }

        let v = control.value.replace(/[^A-z0-9]/gim, '');
        let invalid = !(!isNaN(parseFloat(v)) && isFinite(v));
        return invalid ? {'phonenumber': {value: control.value}} : null;
    };

}


// WEBPACK FOOTER //
// ./src/app/directives/phonevalidator.directive.ts